<template>
    <svg xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 300 150"
        :class="svgClass" 
    >
        <path 
            fill="none" 
            :stroke="strokeColor" 
            :stroke-width="width" 
            stroke-linecap="round" 
            stroke-dasharray="300 385" 
            stroke-dashoffset="0" 
            d="M275 75c0 31-27 50-50 50-58 0-92-100-150-100-28 0-50 22-50 50s23 50 50 50c58 0 92-100 150-100 24 0 50 19 50 50Z"
        >
            <animate 
                attributeName="stroke-dashoffset" 
                calcMode="spline" 
                dur="2" 
                values="685;-685" 
                keySplines="0 0 1 1" 
                repeatCount="indefinite"
            >
            </animate>
        </path>
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';
    
const props = defineProps(['stroke', 'strokeWidth', 'iconClass'])

const strokeColor = computed(() => {
    return props.stroke ? props.stroke : 'white'
})

const width = computed(() => {
    return props.strokeWidth ? props.strokeWidth : 15
})

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-2.5 h-2.5'
})

</script>